import React from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "../components/AppLayout";
import authService from "../services/authService";
import SubscribeButton from "../components/SubscribeButton"; // ✅ importado
import "./Home.css";

export default function Home() {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();

  const ligas = [
    { id: 1, nome: "Premier League" },
    { id: 12, nome: "Championship" },
    { id: 6, nome: "Ligue 1" },
    { id: 54, nome: "Eliteserien" },
    { id: 4, nome: "Serie A" },
    { id: 5, nome: "Bundesliga" },
    { id: 2, nome: "Liga Portugal Betclic" },
    { id: 9, nome: "Brasileirão Série A" },
    { id: 34, nome: "Brasileirão Série B" },
    { id: 39, nome: "Liga Profesional" },
    { id: 7, nome: "Champions League" },
    { id: 8, nome: "Europa League" },
    { id: 32, nome: "Copa Libertadores" },
    { id: 3, nome: "La Liga" },
  ];

  return (
    <AppLayout>
      {/* Bloco superior */}
      <section className="home-header">
        <div className="home-text">
          <h1>
            INTELIGÊNCIA ESPORTIVA<br />BASEADA EM DADOS
          </h1>
          <p>
            Analisamos estatísticas, identificamos padrões e geramos indicadores
            para ajudar você na avaliação de partidas de futebol.
          </p>

          {/* 🔹 Só mostra o botão "Comece Agora" se NÃO estiver logado */}
          {!user && (
            <button
              className="home-button"
              onClick={() => navigate("/login")}
            >
              Comece Agora
            </button>
          )}

          {/* 🔹 Mostra o botão de assinatura se o usuário estiver logado */}
          {user && <SubscribeButton />}
        </div>
        <div className="home-watermark"></div>
      </section>

      {/* Seção de destaques */}
      <section className="home-highlights">
        <div className="highlight-box">
          <h3>📊 Nosso Foco</h3>
          <p>Fornecemos análises detalhadas para apoiar decisões esportivas.</p>
        </div>
        <div className="highlight-box">
          <h3>📈 Resultados Esperados</h3>
          <p>Relatórios precisos e baseados em dados para melhorar o desempenho.</p>
        </div>
        <div className="highlight-box">
          <h3>💡 Indicadores Proprietários</h3>
          <p>Criamos métricas exclusivas que ajudam na avaliação de partidas.</p>
        </div>
        <div className="highlight-box">
          <h3>🔒 Dados Confiáveis</h3>
          <p>Fontes sólidas e métodos estatísticos de alta performance.</p>
        </div>
      </section>

      {/* Ligas disponíveis */}
      <section className="home-leagues">
        <h2>🏆 Ligas Disponíveis</h2>
        <div className="leagues-scroll">
          {ligas.map((liga) => (
            <div key={liga.id} className="league-item">
              <img
                src={`https://sports.bzzoiro.com/img/league/${liga.id}/?bg-transparent`}
                alt={liga.nome}
              />
              <span className="league-name">{liga.nome}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Boxes inferiores */}
      <section className="home-bottom">
        <div className="home-updates">
          <h3>🚀 Próximas Melhorias</h3>
          <ul>
            <li>✔️ Escanteios</li>
            <li>✔️ Cartões</li>
            <li>✔️ Estatísticas ao vivo</li>
            <li>✔️ Basquete</li>
            <li>✔️ Futebol Americano</li>
            <li>✔️ Mais ligas e mercados</li>
          </ul>
        </div>

        <div className="home-feedback-box">
          <h3>💬 Sua Opinião é Importante!</h3>
          <p>Envie sua sugestão de melhoria para tornar o ScannerPro ainda melhor.</p>
          <button
            className="feedback-button"
            onClick={() => navigate("/contato")}
          >
            Enviar Sugestão
          </button>
        </div>
      </section>
    </AppLayout>
  );
}
